export default "__VITE_ASSET__GvM1ANn2__"